(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pws-keuzehulp-koelvries"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const TOTAL_STEPS = 5;

  const INHOUD_MAP = {
    '1-2p': { max: 300 },
    '3-4p': { min: 280, max: 380 },
    '5p':   { min: 340 }
  };

  const BREEDTE_MAP = {
    'smal':      { max: 55 },
    'standaard': { min: 55, max: 65 },
    'ruim':      { min: 68 },
    'any':       {}
  };

  const HOOGTE_MAP = {
    'compact':   { max: 160 },
    'gemiddeld': { min: 160, max: 180 },
    'hoog':      { min: 180 }
  };

  function collectProducts() {
    return Array.from(document.querySelectorAll('#pws-kh-data .pws-kh-product')).map(el => ({
      id:        el.dataset.id,
      title:     el.dataset.title,
      url:       el.dataset.url,
      price:     parseFloat(el.dataset.price) || 0,
      compare:   el.dataset.comparePrice ? parseFloat(el.dataset.comparePrice) : null,
      type:      (el.dataset.type || '').toLowerCase(),
      inhoud:    parseFloat(el.dataset.inhoud) || 0,
      breedte:   parseFloat(el.dataset.breedte) || 0,
      hoogte:    parseFloat(el.dataset.hoogte) || 0,
      db:        parseFloat(el.dataset.db) || 0,
      klasse:    el.dataset.klasse || '',
      nofrost:   el.dataset.nofrost === 'true',
      snelvries: el.dataset.snelvries === 'true',
      snelkoel:  el.dataset.snelkoel === 'true',
      water:     el.dataset.water === 'true',
      kleur:     el.dataset.kleur || '',
      img:       el.dataset.img || '',
      imgAlt:    el.dataset.imgAlt || '',
      available: el.dataset.available !== 'false',
      variantId: el.dataset.variantId || ''
    }));
  }

  function scoreProduct(p, answers) {
    let score = 0;
    const prefs = answers.q3 || [];
    if (prefs.includes('nofrost')   && p.nofrost)   score++;
    if (prefs.includes('quiet')     && p.db > 0 && p.db <= 40) score++;
    if (prefs.includes('snelvries') && p.snelvries) score++;
    if (prefs.includes('snelkoel')  && p.snelkoel)  score++;
    if (prefs.includes('water')     && p.water)     score++;
    if (prefs.includes('eco')       && (p.klasse === 'C' || p.klasse === 'D')) score++;
    return score;
  }

  function passesRange(val, map, key) {
    const b = map[key];
    if (!b || Object.keys(b).length === 0) return true;
    if (!val || val === 0) return true;
    if (b.min !== undefined && val < b.min) return false;
    if (b.max !== undefined && val > b.max) return false;
    return true;
  }

  function passesInhoud(p, key)  { return passesRange(p.inhoud, INHOUD_MAP, key); }
  function passesBreedte(p, key) { return passesRange(p.breedte, BREEDTE_MAP, key); }
  function passesHoogte(p, key)  { return passesRange(p.hoogte, HOOGTE_MAP, key); }

  function passesColor(p, key) {
    if (!key || key === 'any') return true;
    return (p.kleur || '').toLowerCase() === key;
  }

  function match(products, answers) {
    function filter(inhoudKey, breedteKey, hoogteKey, colorKey) {
      return products.filter(p =>
        passesInhoud(p, inhoudKey) &&
        passesBreedte(p, breedteKey) &&
        passesHoogte(p, hoogteKey) &&
        passesColor(p, colorKey)
      );
    }

    var color   = answers.q4;
    let pool    = filter(answers.q0, answers.q1, answers.q2, color);
    let relaxed = false;

    if (pool.length < 3) {
      pool    = filter(answers.q0, answers.q1, null, color);
      relaxed = true;
    }
    if (pool.length < 3) {
      pool    = filter(answers.q0, null, null, color);
      relaxed = true;
    }
    if (pool.length < 3) {
      pool    = filter(null, null, null, color);
      relaxed = true;
    }
    if (pool.length < 3) {
      pool    = products.slice();
      relaxed = true;
    }

    pool.sort((a, b) => {
      const sa = scoreProduct(a, answers);
      const sb = scoreProduct(b, answers);
      if (sb !== sa) return sb - sa;
      return a.price - b.price;
    });

    return { pool: pool.slice(0, 6), relaxed };
  }

  function formatPrice(n) {
    return '€ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function buildCard(p, index) {
    const card = document.createElement('a');
    card.href  = p.url;
    card.className = 'pws-kh__card';
    card.setAttribute('aria-label', p.title);

    const imgHtml = p.img
      ? '<img class="pws-kh__card-img" src="' + p.img + '" alt="' + p.imgAlt + '" loading="lazy" width="400" height="400">'
      : '';
    const badgeHtml = index === 0
      ? '<span class="pws-kh__card-badge">Beste match</span>'
      : '';
    const compareHtml = p.compare
      ? '<span class="pws-kh__card-compare">' + formatPrice(p.compare) + '</span>'
      : '';

    card.innerHTML =
      '<div class="pws-kh__card-img-wrap">' + imgHtml + '</div>' +
      '<div class="pws-kh__card-body">' +
        badgeHtml +
        '<p class="pws-kh__card-title">' + p.title + '</p>' +
        '<p class="pws-kh__card-price">' + formatPrice(p.price) + compareHtml + '</p>' +
      '</div>';

    return card;
  }

  function buildAllLink(answers) {
    const params = new URLSearchParams();
    if (answers.q0) {
      const b = INHOUD_MAP[answers.q0];
      if (b && b.min) params.set('filter.p.m.custom.inhoud_liter_min', b.min);
    }
    const qs = params.toString();
    return '/collections/koel-vriescombinaties' + (qs ? '?' + qs : '');
  }

  document.addEventListener('DOMContentLoaded', function () {
    const widget  = document.getElementById('pws-kh-widget');
    if (!widget) return;

    const stepsWrap   = document.getElementById('pws-kh-steps');
    const resultsWrap = document.getElementById('pws-kh-results');
    const progressBar = widget.querySelector('.pws-kh__progress-bar');
    const progressLbl = widget.querySelector('.pws-kh__progress-label');
    const cardsWrap   = document.getElementById('pws-kh-cards');
    const resultsTitle = document.getElementById('pws-kh-results-title');
    const allLink     = document.getElementById('pws-kh-all-link');
    const restartBtn  = document.getElementById('pws-kh-restart');

    const products = collectProducts();
    const answers  = {};
    let currentStep = 0;

    function getStepEl(n) {
      return stepsWrap.querySelector('[data-step="' + n + '"]');
    }

    function updateProgress(step) {
      const pct = Math.round((step / TOTAL_STEPS) * 100);
      progressBar.style.width = pct + '%';
      progressLbl.textContent = step > 0
        ? 'Vraag ' + step + ' van ' + TOTAL_STEPS
        : '';
    }

    function showStep(n) {
      const steps = stepsWrap.querySelectorAll('.pws-kh__step');
      steps.forEach(function (s) { s.hidden = true; });
      resultsWrap.hidden = true;
      const target = getStepEl(n);
      if (target) {
        target.hidden = false;
        target.querySelector('input')?.focus();
      }
      updateProgress(n + 1);
    }

    function showResults(ans) {
      stepsWrap.querySelectorAll('.pws-kh__step').forEach(function (s) { s.hidden = true; });
      progressBar.style.width = '100%';
      progressLbl.textContent = '';

      const { pool, relaxed } = match(products, ans);

      cardsWrap.innerHTML = '';

      const oldNotice = resultsWrap.querySelector('.pws-kh__relaxed-notice');
      if (oldNotice) oldNotice.remove();

      if (relaxed) {
        const notice = document.createElement('p');
        notice.className = 'pws-kh__relaxed-notice';
        notice.textContent = 'Geen perfecte match gevonden voor deze combinatie - dit zijn de beste opties die het dichtst in de buurt komen.';
        cardsWrap.before(notice);
      }

      pool.forEach(function (p, i) {
        cardsWrap.appendChild(buildCard(p, i));
      });

      resultsTitle.textContent = pool.length + ' geschikte koel-vriescombinaties gevonden';
      allLink.href = buildAllLink(ans);
      resultsWrap.hidden = false;
      resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function wireStep(n) {
      const stepEl = getStepEl(n);
      if (!stepEl) return;

      const isMulti = !!stepEl.querySelector('.pws-kh__check');
      const inputs  = stepEl.querySelectorAll('input');
      const nextBtn = stepEl.querySelector('.pws-kh__btn--next');
      const backBtn = stepEl.querySelector('.pws-kh__btn--back');

      if (!isMulti && nextBtn) {
        nextBtn.disabled = true;
        inputs.forEach(function (inp) {
          inp.addEventListener('change', function () {
            nextBtn.disabled = false;
          });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (isMulti) {
            answers['q' + n] = Array.from(inputs)
              .filter(function (i) { return i.checked; })
              .map(function (i) { return i.value; });
          } else {
            const checked = stepEl.querySelector('input:checked');
            if (!checked) return;
            answers['q' + n] = checked.value;
          }

          if (n === TOTAL_STEPS - 1) {
            showResults(answers);
          } else {
            currentStep = n + 1;
            showStep(currentStep);
          }
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          currentStep = n - 1;
          showStep(currentStep);
        });
      }
    }

    for (let i = 0; i < TOTAL_STEPS; i++) {
      wireStep(i);
    }

    restartBtn.addEventListener('click', function () {
      answers.q0 = answers.q1 = answers.q2 = answers.q3 = answers.q4 = null;
      stepsWrap.querySelectorAll('input').forEach(function (inp) {
        inp.checked = false;
      });
      stepsWrap.querySelectorAll('.pws-kh__btn--next').forEach(function (btn) {
        if (btn.closest('[data-step="3"]') === null) btn.disabled = true;
      });
      currentStep = 0;
      showStep(0);
    });

    showStep(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pws-keuzehulp-wasdroger"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const TOTAL_STEPS = 5;

  const CAPACITY_BUCKETS = {
    '1-2p': { max: 8 },
    '3-4p': { min: 8 },
    '5p':   { min: 9 }
  };

  const DEPTH_MAP = {
    'compact': { max: 60 },
    'normal':  {}
  };

  const BUDGET_MAP = {
    'low':  { max: 450 },
    'mid':  { min: 450, max: 525 },
    'high': { min: 525 }
  };

  function collectProducts() {
    return Array.from(document.querySelectorAll('#pws-kh-data .pws-kh-product')).map(el => ({
      id:        el.dataset.id,
      title:     el.dataset.title,
      url:       el.dataset.url,
      price:     parseFloat(el.dataset.price) || 0,
      compare:   el.dataset.comparePrice ? parseFloat(el.dataset.comparePrice) : null,
      type:      (el.dataset.type || '').toLowerCase(),
      cap:       parseFloat(el.dataset.cap) || 0,
      klasse:    el.dataset.klasse || '',
      sport:     el.dataset.sport === 'true',
      outdoor:   el.dataset.outdoor === 'true',
      antikreuk: el.dataset.antikreuk === 'true',
      kreuk:     el.dataset.kreuk === 'true',
      diepte:    parseFloat(el.dataset.diepte) || 0,
      img:       el.dataset.img || '',
      imgAlt:    el.dataset.imgAlt || '',
      available: el.dataset.available !== 'false',
      variantId: el.dataset.variantId || ''
    }));
  }

  function scoreProduct(p, answers) {
    let score = 0;

    const eco = answers.q1;
    if (eco === 'eco-max' && p.klasse === 'C') score += 2;
    if (eco === 'eco-nice' && (p.klasse === 'C' || p.klasse === 'D')) score += 1;

    const types = answers.q2 || [];
    if (types.includes('sport')     && p.sport)     score++;
    if (types.includes('outdoor')   && p.outdoor)   score++;
    if (types.includes('antikreuk') && p.antikreuk) score++;
    if (types.includes('kreuk')     && p.kreuk)     score++;

    return score;
  }

  function passesCapacity(p, bucketKey) {
    const b = CAPACITY_BUCKETS[bucketKey];
    if (!b) return true;
    if (!p.cap || p.cap === 0) return true;
    if (b.min !== undefined && p.cap < b.min) return false;
    if (b.max !== undefined && p.cap > b.max) return false;
    return true;
  }

  function passesDepth(p, depthKey) {
    const d = DEPTH_MAP[depthKey];
    if (!d || Object.keys(d).length === 0) return true;
    if (!p.diepte || p.diepte === 0) return true;
    if (d.max !== undefined && p.diepte > d.max) return false;
    return true;
  }

  function passesBudget(p, budgetKey) {
    const b = BUDGET_MAP[budgetKey];
    if (!b) return true;
    if (!p.price || p.price === 0) return true;
    if (b.min !== undefined && p.price < b.min) return false;
    if (b.max !== undefined && p.price > b.max) return false;
    return true;
  }

  function match(products, answers) {
    function filter(capKey, depthKey, budgetKey) {
      return products.filter(p =>
        passesCapacity(p, capKey) &&
        passesDepth(p, depthKey) &&
        passesBudget(p, budgetKey)
      );
    }

    let pool    = filter(answers.q0, answers.q3, answers.q4);
    let relaxed = false;

    if (pool.length < 3) {
      pool    = filter(answers.q0, answers.q3, null);
      relaxed = true;
    }
    if (pool.length < 3) {
      pool    = products.slice();
      relaxed = true;
    }

    pool.sort((a, b) => {
      const sa = scoreProduct(a, answers);
      const sb = scoreProduct(b, answers);
      if (sb !== sa) return sb - sa;
      return a.price - b.price;
    });

    return { pool: pool.slice(0, 6), relaxed };
  }

  function formatPrice(n) {
    return '€ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function buildCard(p, index) {
    const card = document.createElement('a');
    card.href  = p.url;
    card.className = 'pws-kh__card';
    card.setAttribute('aria-label', p.title);

    const imgHtml = p.img
      ? '<img class="pws-kh__card-img" src="' + p.img + '" alt="' + p.imgAlt + '" loading="lazy" width="400" height="400">'
      : '';
    const badgeHtml = index === 0
      ? '<span class="pws-kh__card-badge">Beste match</span>'
      : '';
    const compareHtml = p.compare
      ? '<span class="pws-kh__card-compare">' + formatPrice(p.compare) + '</span>'
      : '';

    card.innerHTML =
      '<div class="pws-kh__card-img-wrap">' + imgHtml + '</div>' +
      '<div class="pws-kh__card-body">' +
        badgeHtml +
        '<p class="pws-kh__card-title">' + p.title + '</p>' +
        '<p class="pws-kh__card-price">' + formatPrice(p.price) + compareHtml + '</p>' +
      '</div>';

    return card;
  }

  function buildAllLink(answers) {
    const params = new URLSearchParams();
    if (answers.q0) {
      const b = CAPACITY_BUCKETS[answers.q0];
      if (b && b.min) params.set('filter.p.m.custom.capaciteit_kg_min', b.min);
    }
    if (answers.q4 === 'low')  { params.set('filter.v.price.lte', '450'); }
    if (answers.q4 === 'mid')  { params.set('filter.v.price.gte', '450'); params.set('filter.v.price.lte', '525'); }
    if (answers.q4 === 'high') { params.set('filter.v.price.gte', '525'); }
    const qs = params.toString();
    return '/collections/wasdrogers' + (qs ? '?' + qs : '');
  }

  document.addEventListener('DOMContentLoaded', function () {
    const widget  = document.getElementById('pws-kh-widget');
    if (!widget) return;

    const stepsWrap   = document.getElementById('pws-kh-steps');
    const resultsWrap = document.getElementById('pws-kh-results');
    const progressBar = widget.querySelector('.pws-kh__progress-bar');
    const progressLbl = widget.querySelector('.pws-kh__progress-label');
    const cardsWrap   = document.getElementById('pws-kh-cards');
    const resultsTitle = document.getElementById('pws-kh-results-title');
    const allLink     = document.getElementById('pws-kh-all-link');
    const restartBtn  = document.getElementById('pws-kh-restart');

    const products = collectProducts();
    const answers  = {};
    let currentStep = 0;

    function getStepEl(n) {
      return stepsWrap.querySelector('[data-step="' + n + '"]');
    }

    function updateProgress(step) {
      const pct = Math.round((step / TOTAL_STEPS) * 100);
      progressBar.style.width = pct + '%';
      progressLbl.textContent = step > 0
        ? 'Vraag ' + step + ' van ' + TOTAL_STEPS
        : '';
    }

    function showStep(n) {
      const steps = stepsWrap.querySelectorAll('.pws-kh__step');
      steps.forEach(function (s) { s.hidden = true; });
      resultsWrap.hidden = true;
      const target = getStepEl(n);
      if (target) {
        target.hidden = false;
        target.querySelector('input')?.focus();
      }
      updateProgress(n + 1);
    }

    function showResults(ans) {
      stepsWrap.querySelectorAll('.pws-kh__step').forEach(function (s) { s.hidden = true; });
      progressBar.style.width = '100%';
      progressLbl.textContent = '';

      const { pool, relaxed } = match(products, ans);

      cardsWrap.innerHTML = '';

      const oldNotice = resultsWrap.querySelector('.pws-kh__relaxed-notice');
      if (oldNotice) oldNotice.remove();

      if (relaxed) {
        const notice = document.createElement('p');
        notice.className = 'pws-kh__relaxed-notice';
        notice.textContent = 'Geen perfecte match gevonden voor deze combinatie - dit zijn de beste opties die het dichtst in de buurt komen.';
        cardsWrap.before(notice);
      }

      pool.forEach(function (p, i) {
        cardsWrap.appendChild(buildCard(p, i));
      });

      resultsTitle.textContent = pool.length + ' geschikte wasdrogers gevonden';
      allLink.href = buildAllLink(ans);
      resultsWrap.hidden = false;
      resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function wireStep(n) {
      const stepEl = getStepEl(n);
      if (!stepEl) return;

      const isMulti = !!stepEl.querySelector('.pws-kh__check');
      const inputs  = stepEl.querySelectorAll('input');
      const nextBtn = stepEl.querySelector('.pws-kh__btn--next');
      const backBtn = stepEl.querySelector('.pws-kh__btn--back');

      if (!isMulti && nextBtn) {
        nextBtn.disabled = true;
        inputs.forEach(function (inp) {
          inp.addEventListener('change', function () {
            nextBtn.disabled = false;
          });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (isMulti) {
            answers['q' + n] = Array.from(inputs)
              .filter(function (i) { return i.checked; })
              .map(function (i) { return i.value; });
          } else {
            const checked = stepEl.querySelector('input:checked');
            if (!checked) return;
            answers['q' + n] = checked.value;
          }

          if (n === TOTAL_STEPS - 1) {
            showResults(answers);
          } else {
            currentStep = n + 1;
            showStep(currentStep);
          }
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          currentStep = n - 1;
          showStep(currentStep);
        });
      }
    }

    for (let i = 0; i < TOTAL_STEPS; i++) {
      wireStep(i);
    }

    restartBtn.addEventListener('click', function () {
      answers.q0 = answers.q1 = answers.q2 = answers.q3 = answers.q4 = null;
      stepsWrap.querySelectorAll('input').forEach(function (inp) {
        inp.checked = false;
      });
      stepsWrap.querySelectorAll('.pws-kh__btn--next').forEach(function (btn) {
        if (btn.closest('[data-step="2"]') === null) btn.disabled = true;
      });
      currentStep = 0;
      showStep(0);
    });

    showStep(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pws-keuzehulp"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const TOTAL_STEPS = 4;

  const CAPACITY_BUCKETS = {
    '1p':   { min: 0,  pref: 6  },
    '2p':   { min: 6,  pref: 7  },
    '3-4p': { min: 7,  pref: 8  },
    '5p':   { min: 8,  pref: 10 }
  };
  const BUCKET_ORDER = ['1p', '2p', '3-4p', '5p'];

  const BUDGET_MAP = {
    'low':  { max: 400 },
    'mid':  { min: 400, max: 600 },
    'high': { min: 600 }
  };

  function nextBucket(b) {
    const i = BUCKET_ORDER.indexOf(b);
    return i < BUCKET_ORDER.length - 1 ? BUCKET_ORDER[i + 1] : b;
  }

  function collectProducts() {
    return Array.from(document.querySelectorAll('#pws-kh-data .pws-kh-product')).map(el => ({
      id:          el.dataset.id,
      title:       el.dataset.title,
      url:         el.dataset.url,
      price:       parseFloat(el.dataset.price) || 0,
      compare:     el.dataset.comparePrice ? parseFloat(el.dataset.comparePrice) : null,
      type:        (el.dataset.type || '').toLowerCase(),
      cap:         parseFloat(el.dataset.cap) || 0,
      db:          parseFloat(el.dataset.db) || 0,
      klasse:      el.dataset.klasse || '',
      stoom:       el.dataset.stoom === 'true',
      allergie:    el.dataset.allergie === 'true',
      snel:        el.dataset.snel === 'true',
      kreuk:       el.dataset.kreuk === 'true',
      kinder:      el.dataset.kinder === 'true',
      aqua:        el.dataset.aqua === 'true',
      img:         el.dataset.img || '',
      imgAlt:      el.dataset.imgAlt || '',
      available:   el.dataset.available !== 'false',
      variantId:   el.dataset.variantId || ''
    }));
  }

  function scoreProduct(p, answers) {
    let score = 0;
    const funcs = answers.q2 || [];

    if (funcs.includes('quiet') && p.db > 0 && p.db <= 50)   score++;
    if (funcs.includes('eco')   && ['A','B'].includes(p.klasse)) score++;
    if (funcs.includes('allergy') && (p.allergie || p.stoom)) score++;
    if (funcs.includes('quick') && p.snel)                    score++;
    if (funcs.includes('steam') && (p.stoom || p.kreuk))      score++;
    if (funcs.includes('safety') && (p.kinder || p.aqua))     score++;

    const freq = answers.q1;
    if ((freq === 'daily' || freq === 'heavy') && ['A','B'].includes(p.klasse)) score++;

    return score;
  }

  function passesCapacity(p, bucket) {
    const b = CAPACITY_BUCKETS[bucket];
    if (!b) return true;
    if (p.cap === 0) return true;
    return p.cap >= b.min;
  }

  function passesBudget(p, budgetKey) {
    const b = BUDGET_MAP[budgetKey];
    if (!b) return true;
    if (b.min !== undefined && p.price < b.min) return false;
    if (b.max !== undefined && p.price > b.max) return false;
    return true;
  }

  function match(products, answers) {
    let capBucket = answers.q0;
    const freq     = answers.q1;
    if (freq === 'daily' || freq === 'heavy') {
      capBucket = nextBucket(capBucket);
    }

    function filter(cb, bb) {
      return products.filter(p => passesCapacity(p, cb) && passesBudget(p, bb));
    }

    let pool    = filter(capBucket, answers.q3);
    let relaxed = false;

    if (pool.length < 3) {
      pool    = filter(capBucket, null);
      relaxed = true;
    }
    if (pool.length < 3) {
      pool    = products.slice();
      relaxed = true;
    }

    pool.sort((a, b) => {
      const sa = scoreProduct(a, answers);
      const sb = scoreProduct(b, answers);
      if (sb !== sa) return sb - sa;
      return a.price - b.price;
    });

    return { pool: pool.slice(0, 6), relaxed };
  }

  function formatPrice(n) {
    return '€ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function buildCard(p, index) {
    const card = document.createElement('a');
    card.href  = p.url;
    card.className = 'pws-kh__card';
    card.setAttribute('aria-label', p.title);

    const imgHtml = p.img
      ? '<img class="pws-kh__card-img" src="' + p.img + '" alt="' + p.imgAlt + '" loading="lazy" width="400" height="400">'
      : '';
    const badgeHtml = index === 0
      ? '<span class="pws-kh__card-badge">Beste match</span>'
      : '';
    const compareHtml = p.compare
      ? '<span class="pws-kh__card-compare">' + formatPrice(p.compare) + '</span>'
      : '';

    card.innerHTML =
      '<div class="pws-kh__card-img-wrap">' + imgHtml + '</div>' +
      '<div class="pws-kh__card-body">' +
        badgeHtml +
        '<p class="pws-kh__card-title">' + p.title + '</p>' +
        '<p class="pws-kh__card-price">' + formatPrice(p.price) + compareHtml + '</p>' +
      '</div>';

    return card;
  }

  function buildAllLink(answers) {
    const params = new URLSearchParams();
    if (answers.q0) {
      const b = CAPACITY_BUCKETS[answers.q0];
      if (b && b.min > 0) params.set('filter.p.m.custom.capaciteit_kg_min', b.min);
    }
    if (answers.q3 === 'low')  { params.set('filter.v.price.lte', '400'); }
    if (answers.q3 === 'mid')  { params.set('filter.v.price.gte', '400'); params.set('filter.v.price.lte', '600'); }
    if (answers.q3 === 'high') { params.set('filter.v.price.gte', '600'); }
    const qs = params.toString();
    return '/collections/wasmachines' + (qs ? '?' + qs : '');
  }

  document.addEventListener('DOMContentLoaded', function () {
    const widget  = document.getElementById('pws-kh-widget');
    if (!widget) return;

    const stepsWrap  = document.getElementById('pws-kh-steps');
    const resultsWrap = document.getElementById('pws-kh-results');
    const progressBar = widget.querySelector('.pws-kh__progress-bar');
    const progressLbl = widget.querySelector('.pws-kh__progress-label');
    const cardsWrap   = document.getElementById('pws-kh-cards');
    const resultsTitle = document.getElementById('pws-kh-results-title');
    const allLink     = document.getElementById('pws-kh-all-link');
    const restartBtn  = document.getElementById('pws-kh-restart');

    const products = collectProducts();
    const answers  = {};
    let currentStep = 0;

    function getStepEl(n) {
      return stepsWrap.querySelector('[data-step="' + n + '"]');
    }

    function updateProgress(step) {
      const pct = Math.round((step / TOTAL_STEPS) * 100);
      progressBar.style.width = pct + '%';
      progressLbl.textContent = step > 0
        ? 'Vraag ' + step + ' van ' + TOTAL_STEPS
        : '';
    }

    function showStep(n) {
      const steps = stepsWrap.querySelectorAll('.pws-kh__step');
      steps.forEach(function (s) { s.hidden = true; });
      resultsWrap.hidden = true;
      const target = getStepEl(n);
      if (target) {
        target.hidden = false;
        target.querySelector('input')?.focus();
      }
      updateProgress(n + 1);
    }

    function showResults(ans) {
      stepsWrap.querySelectorAll('.pws-kh__step').forEach(function (s) { s.hidden = true; });
      progressBar.style.width = '100%';
      progressLbl.textContent = '';

      const { pool, relaxed } = match(products, ans);

      cardsWrap.innerHTML = '';

      const oldNotice = resultsWrap.querySelector('.pws-kh__relaxed-notice');
      if (oldNotice) oldNotice.remove();

      if (relaxed) {
        const notice = document.createElement('p');
        notice.className = 'pws-kh__relaxed-notice';
        notice.textContent = 'Geen perfecte match gevonden voor deze combinatie - dit zijn de beste opties die het dichtst in de buurt komen.';
        cardsWrap.before(notice);
      }

      pool.forEach(function (p, i) {
        cardsWrap.appendChild(buildCard(p, i));
      });

      resultsTitle.textContent = pool.length + ' geschikte wasmachines gevonden';
      allLink.href = buildAllLink(ans);
      resultsWrap.hidden = false;
      resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function wireStep(n) {
      const stepEl = getStepEl(n);
      if (!stepEl) return;

      const isMulti   = !!stepEl.querySelector('.pws-kh__check');
      const inputs    = stepEl.querySelectorAll('input');
      const nextBtn   = stepEl.querySelector('.pws-kh__btn--next');
      const backBtn   = stepEl.querySelector('.pws-kh__btn--back');

      if (!isMulti && nextBtn) {
        nextBtn.disabled = true;
        inputs.forEach(function (inp) {
          inp.addEventListener('change', function () {
            nextBtn.disabled = false;
          });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (isMulti) {
            answers['q' + n] = Array.from(inputs)
              .filter(function (i) { return i.checked; })
              .map(function (i) { return i.value; });
          } else {
            const checked = stepEl.querySelector('input:checked');
            if (!checked) return;
            answers['q' + n] = checked.value;
          }

          if (n === TOTAL_STEPS - 1) {
            showResults(answers);
          } else {
            currentStep = n + 1;
            showStep(currentStep);
          }
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          currentStep = n - 1;
          showStep(currentStep);
        });
      }
    }

    for (let i = 0; i < TOTAL_STEPS; i++) {
      wireStep(i);
    }

    restartBtn.addEventListener('click', function () {
      answers.q0 = answers.q1 = answers.q2 = answers.q3 = null;
      stepsWrap.querySelectorAll('input').forEach(function (inp) {
        inp.checked = false;
      });
      stepsWrap.querySelectorAll('.pws-kh__btn--next').forEach(function (btn) {
        if (btn.closest('[data-step="2"]') === null) btn.disabled = true;
      });
      currentStep = 0;
      showStep(0);
    });

    showStep(0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
